const t = {
  image: {
    width: 0,
    height: 0,
    src: "",
    unit: "px"
  }
};
export {
  t as initialState
};
